<template>
<el-dialog
  :visible='true'
  title='服务详情'
  :before-close='handleClose'
  width='1000px'
  :close-on-click-modal='false'
>
<div v-html="content"></div>
</el-dialog>
</template>

<script>

export default {
 name: '' ,
 components: {},
 props:{
  visible: {
    type: Boolean,
    default: false,
  },
  content:{
    type: String,
    default:"",
  }
 },
 data() {
 return {
 
 }
 },
 computed: {},
 created() {
 
 },
 mounted() {
 
 },
 methods: {
  handleClose() {
   this.$emit('close');
  },
  handleConfirm() {
   this.$emit('confirm');
  },
 }
}
</script>
<style lang='scss' scoped>

.dialog-bottom {
  text-align: right;
}
</style>